import React from "react";
import NoDataFoundImg from "../assets/no_data_found.png";

function NoDataFound() {
  return (
    <div className="flex flex-col items-center justify-center h-[65vh]">
      <img
        // src="https://via.placeholder.com/150"
        src={NoDataFoundImg}
        alt="No Data"
        className="mb-4 w-[65%] sm:w-1/2 md:w-[30%]"
      />
      <h2 className="text-2xl font-bold mb-2">No Data Found</h2>
      <p className="text-gray-600">Sorry, we couldn't find any results</p>
    </div>
  );
}

export default NoDataFound;
